// extracted by css-extract-rspack-plugin
export default {"cls1":"CoScientistLandingPage-cls1_zVf","cls2":"CoScientistLandingPage-cls2_L60 CoScientistLandingPage-cls1_zVf"};